import './styles.scss';
import React, {useContext, useState} from "react";
import {Button, Container} from "react-bootstrap";


import {ISearchState} from "../../../types/redux/search";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux";
import * as Constants from "../../../constants";
import {IPageContext, PageContext} from "../../../types/app";

import {useNavigate} from "react-router-dom";
import {NavigateFunction} from "react-router/dist/lib/hooks";
import ToggleNotify from "../../toggle-notify";

import NotificationsModal from "../../modal/notifications-modal";

interface IProps {
  heading: string;
  subHeading?: string;
}

const ViewSubheader = (props: IProps):JSX.Element => {
  const {
    heading,
    subHeading,
  } = props;

  /* state */
  const [showNotifyModal, setShowNotifyModal] = useState<boolean>(false);

  /* redux */
  const searchState: ISearchState = useSelector<RootState, ISearchState>(state => state.search);

  /* context */
  const pageContext: string = useContext<IPageContext>(PageContext).context;

  /* hooks */
  const navigate: NavigateFunction = useNavigate();

  return (
    <Container className={'view-subheading pt-4 pt-lg-3 pb-3 mt-lg-4 w-100'}>
      <div className={'inner'}>
        <div className={'headings me-1 me-lg-3'}>
          <h2 className={'d-inline-block'}>{heading}</h2>
          {subHeading && <h5 className={'text-secondary m-0 mb-1 font-light'}>{subHeading}</h5>}
        </div>

        {(searchState.industry !== Constants.ALL_INDUSTRIES) &&
          (pageContext !== Constants.MY_LIBRARY) &&
            <div className={'float-end d-md-block'}>
              <ToggleNotify
                targetCode={searchState.industry}
                type={'industry'}
              />
            </div>}

        {(searchState.industry === Constants.ALL_INDUSTRIES) &&
          (pageContext !== Constants.MY_LIBRARY) &&
            <div className={'float-end d-md-block text-end'}>
              <Button
                className={'back-btn border-0 btn-icon-only text-dark'}
                onClick={()=>setShowNotifyModal(!showNotifyModal)}
              >
                {!showNotifyModal && <img src={'/assets/images/notification-icon.svg'} alt="" height="30"/>}
                {showNotifyModal && <img src={'/assets/images/notification-icon-selected.svg'} alt="" height="30"/>}
              </Button>

              <div className={'px-0 px-lg-4 container'}>
                <NotificationsModal
                  show={showNotifyModal}
                  close={()=>setShowNotifyModal(false)}
                />
              </div>
            </div>}

        {(pageContext === Constants.MY_LIBRARY) &&
          <div className={'d-inline-block'}>
            <Button
              className={'settings-btn btn-icon-only link-underline-none d-inline-block text-white'}
              onClick={()=>{navigate('/' + Constants.MY_LIBRARY + '/' + Constants.SETTINGS + '/#' + Constants.MY_ACCOUNT)}}
            >
              <i className={'bi bi-gear me-2 me-1 text-white'}/>
              <span>Settings</span>
            </Button>
          </div>}

      </div>
    </Container>
  )
}
export default ViewSubheader;
